import { useState } from 'react';
import { Link } from 'react-router-dom';
import { navCategories } from '@/mocks/navigationData';

export default function FeaturedSites() {
  const [activeCategory, setActiveCategory] = useState(navCategories[0].slug);
  const [activeTab, setActiveTab] = useState<'hot' | 'new'>('hot');

  const currentCategory = navCategories.find((c) => c.slug === activeCategory) || navCategories[0];

  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
        <div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
            精选推荐网站
          </h2>
          <p className="text-sm text-foreground-600">
            经过人工审核筛选的优质网站，让您一键直达
          </p>
        </div>
        <Link
          to={`/category/${activeCategory}`}
          className="flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
        >
          查看全部
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="flex items-center gap-2 mb-6 flex-wrap">
        <div className="flex items-center rounded-full bg-background-100 p-1 mr-2">
          <button
            onClick={() => setActiveTab('hot')}
            className={`px-4 py-1.5 rounded-full text-xs font-medium transition-all duration-200 whitespace-nowrap ${
              activeTab === 'hot'
                ? 'bg-background-50 text-foreground-950 shadow-sm'
                : 'text-foreground-500 hover:text-foreground-700'
            }`}
          >
            热门推荐
          </button>
          <button
            onClick={() => setActiveTab('new')}
            className={`px-4 py-1.5 rounded-full text-xs font-medium transition-all duration-200 whitespace-nowrap ${
              activeTab === 'new'
                ? 'bg-background-50 text-foreground-950 shadow-sm'
                : 'text-foreground-500 hover:text-foreground-700'
            }`}
          >
            最新收录
          </button>
        </div>
        <div className="h-5 w-px bg-background-300 hidden sm:block"></div>
        <div className="flex items-center gap-1.5 flex-wrap">
          {navCategories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => setActiveCategory(cat.slug)}
              className={`px-3 py-1.5 rounded-full text-xs font-medium transition-all duration-200 whitespace-nowrap ${
                activeCategory === cat.slug
                  ? 'bg-accent-100 text-accent-700'
                  : 'text-foreground-500 hover:text-foreground-700 hover:bg-background-100'
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4" data-product-shop="">
        {currentCategory.sites.map((site) => (
          <a
            key={site.id}
            href={site.url}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="group flex items-start gap-3.5 p-4 bg-background-50 rounded-xl border border-background-200 hover:border-accent-300 transition-all duration-200 hover:-translate-y-0.5"
          >
            <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-xl bg-background-100 text-foreground-600 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors duration-200">
              <i className={`${site.icon} text-lg`}></i>
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-1">
                <h3 className="font-heading text-sm font-bold text-foreground-950 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  {site.name}
                </h3>
                {activeTab === 'new' && (
                  <span className="inline-flex items-center px-1.5 py-0.5 rounded-full bg-accent-100 text-accent-700 text-[10px] font-medium whitespace-nowrap">
                    新
                  </span>
                )}
              </div>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-1">
                {site.description}
              </p>
              <div className="flex items-center gap-1.5 mt-2 flex-wrap">
                {site.tags.map((tag) => (
                  <span
                    key={tag}
                    className="inline-block px-2 py-0.5 rounded-md bg-background-100 text-foreground-500 text-[10px] whitespace-nowrap"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
            <div className="flex-shrink-0 pt-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
              <i className="ri-external-link-line text-foreground-400 text-sm"></i>
            </div>
          </a>
        ))}
      </div>

      {currentCategory.sites.length > 6 && (
        <div className="text-center mt-8">
          <Link
            to={`/category/${activeCategory}`}
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-background-300 text-foreground-600 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-all duration-200"
          >
            浏览全部 {currentCategory.name} 网站
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      )}
    </section>
  );
}